module.exports = __webpack_public_path__ + "img/VP-Standard_Overview-Front_3.f8582902.jpg";